import { render, staticRenderFns } from "./AdminAddPromotion2022.vue?vue&type=template&id=e0a2d9fe&scoped=true"
import script from "./AdminAddPromotion2022.vue?vue&type=script&lang=js"
export * from "./AdminAddPromotion2022.vue?vue&type=script&lang=js"
import style0 from "./AdminAddPromotion2022.vue?vue&type=style&index=0&id=e0a2d9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a2d9fe",
  null
  
)

export default component.exports